import React from 'react';
import { Paper, Box, ButtonGroup, Button } from '@material-ui/core';

const StateFilterComponent = ({
  insightsStatusFilter,
  value,
  setInsightsStatusFilter,
  setFilteredTableData
}) => /* @__PURE__ */ React.createElement(Paper, null, /* @__PURE__ */ React.createElement(Box, { position: "absolute", right: 350, top: 20 }, /* @__PURE__ */ React.createElement(ButtonGroup, { color: "primary", "aria-label": "text primary button group" }, /* @__PURE__ */ React.createElement(
  Button,
  {
    color: insightsStatusFilter === "open" ? "primary" : "default",
    onClick: () => {
      setInsightsStatusFilter(
        insightsStatusFilter === "open" ? null : "open"
      );
      if (value) {
        setFilteredTableData(
          value.filter((entry) => entry.state === "open")
        );
      }
    }
  },
  "OPEN"
), /* @__PURE__ */ React.createElement(
  Button,
  {
    color: insightsStatusFilter === "fixed" ? "primary" : "default",
    onClick: () => {
      setInsightsStatusFilter(
        insightsStatusFilter === "fixed" ? null : "fixed"
      );
      if (value) {
        setFilteredTableData(
          value.filter((entry) => entry.state === "fixed")
        );
      }
    }
  },
  "FIXED"
), /* @__PURE__ */ React.createElement(
  Button,
  {
    color: insightsStatusFilter === "dismissed" ? "primary" : "default",
    onClick: () => {
      setInsightsStatusFilter(
        insightsStatusFilter === "dismissed" ? null : "dismissed"
      );
      if (value) {
        setFilteredTableData(
          value.filter((entry) => entry.state === "dismissed")
        );
      }
    }
  },
  "DISMISSED"
))));

export { StateFilterComponent };
//# sourceMappingURL=StateFilterComponent.esm.js.map
